import { useI18n } from 'vue-i18n';
import useCustomerTools from 'hooks/useCustomerTools';
import useCartTools from 'hooks/useCartTools';

import CartLikeContentDetail from 'presentation/CartDetail/CartLikeContentDetail/CartLikeContentDetail.vue';
import CartLikePriceDetail from 'presentation/CartDetail/CartLikePriceDetail/CartLikePriceDetail.vue';
import Spinner from 'presentation/components/Spinner/Spinner.vue';

import { shallowRef, watch } from 'vue';
export default {
    components: {
        CartLikeContentDetail,
        CartLikePriceDetail,
        Spinner
    },
    props: {
        quoteRefetch: {
            type: Function
        }
    },
    setup(){
        const { t } = useI18n();
        const tools = useCustomerTools();
        const { quote, loading, error } = tools.useMyQuote();
        const quoteComment = shallowRef(null);
        const discountType = shallowRef('direct');
        const discountValue = shallowRef(null);
        const discountTotal = shallowRef(0);
        watch(discountValue, (discountValue)=>{
            discountTotal.value = 0;
            if(discountValue == 0){
                quote.value.lineItems.map((item)=>discountTotal.value+=item.totalPrice.centAmount);
                console.log(discountTotal.value)
            }
            else if(discountValue <= 80 && discountValue > 0) {
                quote.value.lineItems.map((item)=>discountTotal.value+=item.totalPrice.centAmount);
                discountTotal.value = discountTotal.value - (discountTotal.value * (discountValue/100))
            } else {
                discountTotal.value = 0;
            }
        })
        return {
            ...useCartTools(),
            t,
            loading,
            error,
            quote,
            quoteComment,
            discountType,
            discountValue,
            discountTotal
        }
    }
}